document.addEventListener('DOMContentLoaded', function () {
  if (typeof grained !== 'function') {
    console.error('grained.js not loaded or grained is not a function.');
    return;
  }
  grained('#grainedBackground', {
    animate: false,
    patternWidth: 100,
    patternHeight: 100,
    grainOpacity: 0.03,
    grainDensity: 2,
    grainWidth: 2,
    grainHeight: 3,
    grainSpeed: 5,
    grainChaos: 5
  });

  //marquee
  if(document.querySelector(".marquee-splide")) {
  new Splide('.marquee-splide', {
    type: 'loop',
    drag: 'free',
    autoWidth: true,
    pagination: false,
    arrows: false,
    autoScroll: {
      speed: 0.8,
    },
  }).mount(window.splide.Extensions);
}

  // best seller products
  if(document.querySelector("#ct-bs-splide")) {
  new Splide('#ct-bs-splide', {
      type: 'loop',
      perPage: 1,
      pagination: false,
      arrows: true,
      gap: '20px',
    }).mount();
  }
});

 

// let cart_splide;
// function initCartSwiper() {
//   if (cart_splide) {
//     cart_splide.destroy(true, true);
//   }
//    const ct_cart_splide = new Splide(".cart_product_list", {
//       arrows: false,
//       pagination: true,
//       cover: true,
//       perPage: 3,
//       gap: 10,
//       perMove: 1,
//     });
//       ct_cart_splide.mount();
// }
// initCartSwiper();

// PDP accordion script start //
document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector(".product__accordion details")) {
  const accordions = document.querySelectorAll(".product__accordion details");

  accordions.forEach((accordion) => {
    accordion.addEventListener("toggle", function () {
      if (this.open) {
        accordions.forEach((other) => {
          if (other !== this) other.removeAttribute("open");
        });
      }
    });
  });
  }
});

// PDP accordion script End //

// ------- product page add to cart button sticky ------
if(document.querySelector(".add-to-cart-wrapper")) {
document.addEventListener("DOMContentLoaded", () => {
  const addToCartWrapper = document.querySelector(".add-to-cart-wrapper");
  const footer = document.querySelector("footer");
  const header = document.querySelector("header");

  const originalPosition = addToCartWrapper.getBoundingClientRect().top + window.scrollY;
  const buffer = 20;

  window.addEventListener("scroll", () => {
    const scrollY = window.scrollY;
    const footerOffset = footer.getBoundingClientRect().top + window.scrollY;

    // Detect header sticky (CSS sticky)
    const isHeaderSticky = header.getBoundingClientRect().top <= 0;

    // Add to cart sticky only after header becomes sticky
    if (isHeaderSticky && scrollY > originalPosition - header.offsetHeight - buffer) {
      addToCartWrapper.classList.add("fixed-bottom");
    } else {
      addToCartWrapper.classList.remove("fixed-bottom");
    }

    // Footer logic
    if (scrollY + window.innerHeight >= footerOffset) {
      addToCartWrapper.classList.add("at-footer");
    } else {
      addToCartWrapper.classList.remove("at-footer");
    }
  });
});
}


// ------- product page add to cart button sticky ------

// Cart drawer complete yor routine scripr
 
if (document.querySelector(".ct_routine_wrapper")) {
  var routine_slider = new Splide(".ct_routine_wrapper", {
    type: 'loop',
    drag: 'free',
    perPage: 3,
    gap: '12px',
    speed: 1200,
    arrows: true,
    pagination: false
  });

  routine_slider.mount();
}
$(document).on("click", ".gfgFGv2-action", function() {
setTimeout(function() {
var routine_slider = new Splide(".ct_routine_wrapper", {
    type: 'loop',
    drag: 'free',
    perPage: 3,
    gap: '12px',
    speed: 1200,
    arrows: true,
    pagination: false
  });

  routine_slider.mount();
}, 3000);
});



document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector(".cart-drawer__footer");
  const paymentSummary = document.querySelector(".ct_payment_summary");

  if (footer && paymentSummary) {
    footer.addEventListener("click", function () {
      paymentSummary.classList.toggle("active");
    });
  }
}); 



// document.addEventListener("DOMContentLoaded", function () {

//   function updateCartProgress() {

//     fetch('/cart.js')
//       .then(response => response.json())
//       .then(cart => {

//         const itemCount = cart.item_count;
//         const progressFill = document.querySelector(".progress-fill");

//         if (!progressFill) return;

//         let width = "0%";

//         if (itemCount == 1) {
//           width = "33%";
//         } 
//         else if (itemCount == 2) {
//           width = "66%";
//         } 
//         else if (itemCount >= 3) {
//           width = "100%";
//         }

//         progressFill.style.width = width;

//       });
//   }

//   updateCartProgress();

//   document.body.addEventListener('click', function(e){

//     if(
//       e.target.closest('button[name="add"]') ||
//       e.target.closest('.quantity__button') ||
//       e.target.closest('cart-remove-button')
//     ) {

//       setTimeout(() => {
//         updateCartProgress();
//       }, 800);

//     }

//   });

// }); 


// Cart drawer complete yor routine script




// Newsletter popup script

// $(document).ready(function () {
//   const popupKey = 'newsletter_popup_closed';

//   if (!localStorage.getItem(popupKey)) {
//     setTimeout(() => {
//       $('.ct_newsletter_popup').addClass('active');
//     }, 10000);
//   }

//    $(document).on('click', '.ct-popup-close', function () {
//     $('.ct_newsletter_popup').removeClass('active');
//     localStorage.setItem(popupKey, 'true');
//   });
// });

// Newsletter popup script End


